import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=59a37031"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"
import style0 from "./salary.vue?vue&type=style&index=0&id=59a37031&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports